import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";

const CATEGORIES = [
  { to: "/category/movie", label: "电影", icon: "ri-film-line" },
  { to: "/category/tv", label: "电视剧", icon: "ri-tv-2-line" },
  { to: "/category/variety", label: "综艺", icon: "ri-mic-line" },
];

export default function MobileTabBar() {
  const [sheet, setSheet] = useState<"" | "category" | "search">("");
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { count } = useFavorites();

  useEffect(() => {
    setSheet("");
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/category/movie?keyword=${encodeURIComponent(kw)}&scope=all`);
    setKeyword("");
    setSheet("");
  };

  const tabs = [
    { key: "home", label: "首页", icon: "ri-home-5-line", active: location.pathname === "/", to: "/" },
    { key: "category", label: "分类", icon: "ri-apps-2-line", active: location.pathname.startsWith("/category"), onClick: () => setSheet(sheet === "category" ? "" : "category") },
    { key: "search", label: "搜索", icon: "ri-search-line", active: false, onClick: () => setSheet(sheet === "search" ? "" : "search") },
    { key: "favorites", label: "收藏", icon: "ri-heart-3-line", active: location.pathname === "/favorites", to: "/favorites" },
  ];

  return (
    <>
      {sheet && (
        <div
          className="fixed inset-0 z-40 bg-background-950/60 md:hidden"
          onClick={() => setSheet("")}
        ></div>
      )}

      {sheet === "category" && (
        <div className="fixed inset-x-0 bottom-[68px] z-[45] mx-3 rounded-xl border border-background-800 bg-background-900 p-4 animate-fade-up md:hidden">
          <p className="mb-3 text-sm font-medium text-foreground-200">选择内容分类</p>
          <div className="grid grid-cols-3 gap-3">
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.to}
                to={cat.to}
                className="flex flex-col items-center gap-2 rounded-lg border border-background-800 bg-background-950 py-4 text-foreground-200"
              >
                <i className={`${cat.icon} text-xl text-primary-400`}></i>
                <span className="text-xs">{cat.label}</span>
              </Link>
            ))}
          </div>
        </div>
      )}

      {sheet === "search" && (
        <div className="fixed inset-x-0 bottom-[68px] z-[45] mx-3 rounded-xl border border-background-800 bg-background-900 p-4 animate-fade-up md:hidden">
          <p className="mb-3 text-sm font-medium text-foreground-200">搜索影视</p>
          <form onSubmit={submitSearch} className="flex items-center rounded-md border border-background-700 bg-background-950 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              autoFocus
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入片名关键词"
              className="w-full bg-transparent px-2 text-sm text-foreground-100 outline-none placeholder:text-foreground-600"
            />
            <button type="submit" className="whitespace-nowrap text-sm font-medium text-primary-400">搜索</button>
          </form>
        </div>
      )}

      <nav className="fixed inset-x-0 bottom-0 z-50 flex h-[68px] items-center justify-around border-t border-background-800 bg-background-950/98 backdrop-blur md:hidden">
        {tabs.map((tab) =>
          tab.to ? (
            <Link
              key={tab.key}
              to={tab.to}
              className={`flex h-full flex-1 flex-col items-center justify-center gap-1 ${
                tab.active ? "text-primary-400" : "text-foreground-400"
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="text-[11px]">{tab.label}</span>
            </Link>
          ) : (
            <button
              key={tab.key}
              type="button"
              onClick={tab.onClick}
              className={`flex h-full flex-1 flex-col items-center justify-center gap-1 ${
                tab.active ? "text-primary-400" : "text-foreground-400"
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="text-[11px]">{tab.label}</span>
            </button>
          ),
        )}
      </nav>
    </>
  );
}